/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { FlexMiddleStyled } from '../../Block/Flexbox';


export const RangeMonthPickerButtonStyled = styled(FlexMiddleStyled).attrs({
    classname: 'range-month-picker__drop-down-btn',
})`
    box-sizing: border-box;
    height: 100%;
    padding: 8px 12px;
    cursor: pointer;
    background-color: ${colors.backgroundColorWhite};
    border: 1px solid ${colors.borderColorDisabled};
    ${fonts.textSmall};

    .drop-down-btn__icon {
        margin-left: 12px;
    }
`;
